import { Routes } from '@angular/router';
import {
  isAuthenticatedGuard,
  isCustomerGuard,
  isEnvironmentGuard,
} from './routes.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./portal/pages/auth-login/session-login/session-login.component').then(
        mod => mod.SessionLoginComponent,
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./portal/pages/auth-login/session-reset-password/session-reset-password.component').then(
        mod => mod.SessionResetPasswordComponent,
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./portal/pages/auth-login/forgot-password/forgot-password.component').then(
        mod => mod.ForgotPasswordComponent,
      ),
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./portal/pages/auth-login/session-sign-up/sign-up.component').then(
        mod => mod.SignUpComponent,
      ),
  },
  {
    canActivate: [isAuthenticatedGuard],
    path: '',
    loadComponent: () =>
      import('./portal/layout/component/layout/app.layout').then(
        mod => mod.AppLayout,
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./portal/pages/shell/shell-home-page/shell-home-page.component').then(
            mod => mod.ShellHomePageComponent,
          ),
      },
      {
        path: 'reseller',
        // canActivate: [isResellerGuard],
        loadChildren: () =>
          import('./portal/pages/reseller/reseller.routes').then(
            mod => mod.RESELLER_ROUTES,
          ),
      },
      {
        path: 'reseller-apn-rbu',
        // canActivate: [isResellerGuard],
        loadChildren: () =>
          import('./portal/pages/reseller-apm-rbu/reseller-apn-rbu.routes').then(
            mod => mod.RESELLER_APN_RBU_ROUTES,
          ),
      },
      {
        path: 'customer',
        canActivate: [isCustomerGuard],
        loadChildren: () =>
          import('./portal/pages/customer/customer.routes').then(
            mod => mod.CUSTOMER_ROUTES,
          ),
      },
      {
        path: 'environment',
        canActivate: [isEnvironmentGuard],
        loadChildren: () =>
          import('./portal/pages/environment/environment.routes').then(
            mod => mod.ENVIRONMENT_ROUTES,
          ),
      },
      // {
      //   path: 'not-authorized',
      //   loadComponent: () =>
      //     import(
      //       './portal/pages/root/not-authorized-page/not-authorized-page.component'
      //     ).then(mod => mod.NotAuthorizedPageComponent),
      // },
      {
        path: '**',
        pathMatch: 'full',
        loadComponent: () =>
          import('./portal/pages/root/page-not-found/page-not-found-page.component').then(
            mod => mod.PageNotFoundPageComponent,
          ),
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    loadComponent: () =>
      import('./portal/pages/root/page-not-found/page-not-found-page.component').then(
        mod => mod.PageNotFoundPageComponent,
      ),
  },
];
